import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux";
import { deleteTimeslotAll, updateSelectCategoryPrenotation } from "../../redux/reducer/timeslotReducer";
import DatePickerTimeslot from "../common/datePickerTimeslot";
import FullCalendarTimeslot from "../common/fullcalendarTimeslot";
import ListServiceTimeslot from "../listServiceTimeslot";
import PopUpEditService from "../popUpEditService";
import PopUpDeleteTimeslotByService from "../popUpEditService/popUpDeleteTimeslotByService";
import PopUpManagerTimeslot from "./popUpManagerTimeslot";
import { HttpService } from "../../services/HttpService";

const ManagerTimeslot = () => {
  const dispacth = useAppDispatch();
  const [date, setDate] = useState(new Date());
  const [timeslotDays, setTimeslotDays] = useState([new Date()]);
  const [monthShow, setMonthShow] = useState(new Date());
  const { rangEvent } = useSelector((state: any) => state.login);
  const [showManagerTimeslot, setShowManagerTimeslot] = useState(false);
  const [componentManagerTimeslot, setComponentManagerTimeslot] = useState("");
  const [idService, setIdService] = useState("");
  const [showDelete, setShowDelet] = useState(false);
  const [idEvent, setIdEvent] = useState("");
  const { eventId } = useSelector((state: any) => state.login);
  // array of categoryIds selected in the left bar
  const { filter } = useSelector((state: any) => state.timeslot);
  const { timeslotUpdate } = useSelector((state: any) => state.timeslot);
  const [dateSelectTimeslot, setDateSelectTimeslot] = useState(new Date());
  const [timeslotAvailabilityDate, setTimeslotAvailabilityDate] = useState([{ startTime: "", endTime: "" }])
  const eventsSourceUrl = `t4event/api/v01/event/${eventId}/fullcalendar/timeslots`;
  const [internalServiceNames, setInternalServiceNames] = useState<null | [any]>(null);
  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);
  /**
   * Click on a timeslot in calendar, open edit interface.
   * @param arg Fullcalendar arg, contains event details.
   */
  const eventClick = (arg: any) => {
    setShowManagerTimeslot(true);
    setIdEvent(arg.event.extendedProps.timeslotId); // NOTE!! TimeslotId!! Not Event ID!!
    setComponentManagerTimeslot("ViewTimeslot");
  }

  const OpenCreteTimeslot = () => {
    setShowManagerTimeslot(true);
    dispacth(updateSelectCategoryPrenotation(""))
    setComponentManagerTimeslot("CreateTimeslot");
  }
  const dateClick = (info: any) => {
    setDateSelectTimeslot(info.date);
    let day = moment(info.date);

    setTimeslotAvailabilityDate([{ startTime: day.format("HH:mm"), endTime: day.add(1, 'hours').format("HH:mm") }])
    OpenCreteTimeslot();
  }
  const clickServiceSettings = (id: any) => {
    setIdService(id)


  }
  const clickServiceCreateTimeslot = (id: any) => {
    setShowManagerTimeslot(true);
    dispacth(updateSelectCategoryPrenotation(id))
    setComponentManagerTimeslot("CreateTimeslot");
  }

  const closePopUp = () => {
    setIdService("")
  }

  const deleteAllTimeslot = async () => {
    await dispacth(deleteTimeslotAll());
    setShowDelet(false)
  }

  const loadTimeslotDays = async () => {
    let startDate = moment(monthShow).startOf('month').format("YYYY-MM-DD");
    let endDate = moment(monthShow).endOf('month').format("YYYY-MM-DD");
    const params = [
      `startDate=${startDate}`,
      `endDate=${endDate}`,
      `categories=${filter}`
    ]
    const result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/days?${params.join('&')}`);
    if (result.status === 200) {
      setTimeslotDays(result.data)
    }
  }

  const initInternalServiceName = async (serviceNamesDisabled: [string]) => {
    const { data } = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/settings/internal-timeslot-names`)
    setInternalServiceNames(data.map((internalServiceName: any) => {
      return {
        value: internalServiceName,
        label: internalServiceName,
        disabled: ((serviceNamesDisabled.includes(internalServiceName)) ? true : false)
      }
    }));
  }

  const uploadInternalServiceName = async (serviceNamesDisabled: [string]) => {
    const newInternalServiceNames: any = internalServiceNames?.map((internalServiceName: any) => {
      return {
        value: internalServiceName.value,
        label: internalServiceName.label,
        disabled: ((serviceNamesDisabled.includes(internalServiceName.value)) ? true : false)
      }
    })
    setInternalServiceNames(newInternalServiceNames);
  };
  const loadInternalServiceName = async () => {
    let serviceNamesDisabled = categoryPrenotation.map((service: any) => { return service.name });
    if (internalServiceNames === null) {
      initInternalServiceName(serviceNamesDisabled)
    }
    else {
      uploadInternalServiceName(serviceNamesDisabled)
    }
  }


  useEffect(() => {
    loadTimeslotDays()
  }, [monthShow, filter, timeslotUpdate])

  useEffect(() => {
    loadInternalServiceName();
  }, [categoryPrenotation])

  return (
    <>
      <div className="Section">
        <div className="row m-0">
          <div className="col-lg-3 pt-3">
            <DatePickerTimeslot minDate={rangEvent?.startDate} maxDate={rangEvent?.endDate} setMonthShow={setMonthShow} highlights={timeslotDays} date={date} handleChange={setDate} />
            <ListServiceTimeslot clickServiceEdit={clickServiceCreateTimeslot} clickServiceSettings={clickServiceSettings} />
          </div>
          <div className="col-lg-9">
            <FullCalendarTimeslot
              typeCalendar="managerTimeslot"
              inizialDate={date}
              eventClick={eventClick}
              dateClick={dateClick}
              eventsSourceUrl={eventsSourceUrl}
              categoryIds={filter}
            />

          </div>
        </div>

      </div>
      <PopUpDeleteTimeslotByService
        handleCloseSecondary={() => (setShowDelet(false))}
        handleClosePrimary={() => (deleteAllTimeslot())}
        closeModal={() => (setShowDelet(false))}
        show={showDelete} />

      <PopUpEditService
        internalServiceNames={internalServiceNames}
        closeModal={closePopUp}
        id={idService}
        show={(idService !== "")}
      />
      <PopUpManagerTimeslot
        idEvent={idEvent}
        dateSelect={dateSelectTimeslot}
        timeslotAvailabilityDate={timeslotAvailabilityDate}
        showComponent={componentManagerTimeslot}
        closePopUp={() => (setShowManagerTimeslot(false))}
        show={showManagerTimeslot}
      />
    </>

  )
}

export default ManagerTimeslot